<template>
  <el-container style="height: 100%;overflow: hidden;" class="app-wrapper">
    <el-header>
      <app-header />
    </el-header>
    <el-container :class="classObj">
      <div v-if="notSidebar">
        <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <sidebar class="sidebar-container" />
      </div>
      <el-main>
        <div :class="{'fixed-header':''}">
          <navbar />
        </div>
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { AppHeader, Navbar, Sidebar, AppMain } from './components'
  import ResizeMixin from './mixin/ResizeHandler'

  export default {
    name: 'Layout',
    components: {
      AppHeader,
      Navbar,
      Sidebar,
      AppMain
    },
    mixins: [ResizeMixin],
    mounted() {
      window.onresize = () => {
        return (() => {
          this.windowWidth = document.documentElement.clientWidth; // 宽
        })()
      };
    },
    data() {
      return {
        windowWidth: document.documentElement.clientWidth,
      }
    },
    watch: {
      windowWidth(val) {
        this.windowWidth = val
      },
    },
    computed: {
      sidebar() {
        return this.$store.state.app.sidebar
      },
      device() {
        return this.$store.state.app.device
      },
      fixedHeader() {
        return this.$store.state.settings.fixedHeader
      },
      classObj() {
        return {
          hideSidebar: !this.sidebar.opened,
          openSidebar: this.sidebar.opened,
          withoutAnimation: this.sidebar.withoutAnimation,
          mobile: this.device === 'mobile'
        }
      },
      // 没有三四级菜单的页面地址
      notSidebar() {
        let localMenu = window.localStorage.getItem('menu')
        if (localMenu && localMenu != 'undefined') {
          let menu = JSON.parse(localMenu)
          let menuData = menu.menu23
          let notSidebarPath = ['/dashboard', '/personInsert', '/asset/dormitory', '/assistant/viewAssistant',
            '/meta/page/viewAttr', '/playerDetail',
            '/empDetail', '/organization/baseCheckSummary', '/examination/examinationPaper',
            '/utilsAll',""
          ] //用来保存没有三四级菜单的地址//宿舍管理暂时没有三四级菜单
          if (menuData) {
            menuData.forEach(item => {
              if (item.children.length == 0) {
                notSidebarPath.push(item.url)
              }
            })
          }
          return notSidebarPath.indexOf(this.$route.path) < 0 && window.localStorage.getItem('path')
        } else {
          this.$store.dispatch('user/logout')
          this.$router.push(`/login`)
        }
      }
    },
    // created() {
    //   this.setSessionStorage()
    // },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
      },
      setSessionStorage() {
        if (!sessionStorage.length) {
          // 这个调用能触发目标事件，从而达到共享数据的目的
          localStorage.setItem('getSessionStorage', Date.now());
        };
        // 该事件是核心
        window.addEventListener('storage', function(event) {
          if (event.key == 'getSessionStorage') {
            // 已存在的标签页会收到这个事件
            localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
            localStorage.removeItem('sessionStorage');
          } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
            // 新开启的标签页会收到这个事件
            var data = JSON.parse(event.newValue),
              value;
            for (let key in data) {
              sessionStorage.setItem(key, data[key]);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
